export default [
  {
    path: 'inbox',
    name: 'inbox',
    component: () => import('@/views/pages/inbox/Inbox.vue'),
    meta: {
      pageTitle: 'Inbox',
      breadcrumb: [
        {
          text: 'Inbox',
          active: true,
        },
      ],
      resource: 'Letter',
    },
  },
  {
    path: 'inbox/:id',
    name: 'inbox-view',
    component: () => import('@/views/pages/inbox/View.vue'),
    meta: {
      pageTitle: 'Inbox',
      breadcrumb: [
        {
          to: { name: 'inbox' },
          text: 'Inboxes',
          active: false,
        },
        {
          text: 'View',
          active: true,
        },
      ],
      resource: 'Letter',
    },
  },
  {
    path: 'inbox/:id/history',
    name: 'inbox-history',
    component: () => import('@/views/pages/inbox/History.vue'),
    meta: {
      pageTitle: 'Inbox',
      breadcrumb: [
        {
          to: { name: 'inbox' },
          text: 'Inboxes',
          active: false,
        },
        {
          text: 'History',
          active: true,
        },
      ],
      resource: 'Letter',
    },
  },
]
